import { ReactNode } from "react";
import AmountIcon from "../../assets/icons/AmountIcon";
import ApplicantIcon from "../../assets/icons/ApplicantIcon";
import ExperienceIcon from "../../assets/icons/ExperienceIcon";
import LocationIcon from "../../assets/icons/LocationIcon";
import TimeIcon from "../../assets/icons/TimeIcon";
import { EType, JType } from "../../pages/admin/JobPost/JobPost";
import { JobPostDetail } from "../../types";

type Props = {
  children?: ReactNode;
  companyName: string;
  location?: string;
  available?: number | null;
  experience?: string;
  salary?: string;
  companyLink?: string;
  jobTitle?: string;
  jobType?: JobPostDetail["employment_type"];
  type?: JobPostDetail["employment_status"];
};

export default function JobCard({
  children,
  companyName,
  location,
  available,
  experience,
  salary,
  type,
  jobTitle,
  jobType,
  companyLink,
}: Props) {
  return (
    <>
      <div className="max-w-[525px] bg-[#001652] p-6 rounded-md">
        <h2 className="text-white text-2xl font-semibold">{jobTitle}</h2>
        <h4 className="text-white text-base font-medium pb-4">
          {companyLink ? (
            <a
              href={companyLink}
              className="!text-white"
              target="_blank"
              rel="noreferrer"
            >
              {companyName}
            </a>
          ) : (
            companyName
          )}
        </h4>
        <div className="outline outline-1 outline-offset-[-0.50px] outline-orange-50" />
        <div className="pt-4 inline-grid grid-cols-2 gap-4">
          <Item icon={<LocationIcon />} text={location || "N/A"} />
          {available ? (
            <Item icon={<ApplicantIcon />} text={`${available} Available`} />
          ) : null}
          <Item
            icon={<ExperienceIcon />}
            text={`${experience} ${
              Number(experience) === 1 ? "Year" : "Years"
            }`}
          />
          <Item icon={<AmountIcon />} text={salary || "Negotiable"} />
          <Item icon={<TimeIcon />} text={type ? EType[type] : "N/A"} />
          <Item icon={<TimeIcon />} text={jobType ? JType[jobType] : "N/A"} />
        </div>
        <div>{children}</div>
      </div>
    </>
  );
}

type TItem = {
  icon: ReactNode;
  text: string;
};

const Item = ({ icon, text }: TItem) => {
  return (
    <div className="inline-flex items-center gap-3 text-white">
      {icon}
      <span className="text-white text-sm font-normal">{text}</span>
    </div>
  );
};
